export default __webpack_public_path__ + "static/media/3.902547d7.jpg";